module.exports = {
  pageView: function () {
    ga && ga('send', 'pageview');

    ga && ga(function () {
      var mtnTracker = ga.getByName('mtnTracker');
      if (mtnTracker) {
        ga('mtnTracker.send', 'pageview');
      }

      var surfTracker = ga.getByName('surfTracker');
      if (surfTracker) {
        ga('surfTracker.send', 'pageview');
      }
    });
  }
};
